import { EBookType, EMarpolBookId, IBook } from './types';

const inspectorConstants = {
	FEATURE: '@inspector',
};

export const marpolBooks: Array<IBook> = [
	{
		id: EMarpolBookId.ORB1,
		title: 'Oil Record Book Part 1',
		type: 'MARPOL',
		bookType: EBookType.MARPOL,
	},
	{
		id: EMarpolBookId.ORB4,
		title: 'Oil Record Book Part 2',
		type: 'MARPOL',
		bookType: EBookType.MARPOL,
	},
	{
		id: EMarpolBookId.CRB,
		title: 'Cargo Record Book',
		type: 'MARPOL',
		bookType: EBookType.MARPOL,
	},
	{
		id: EMarpolBookId.GRB1,
		title: 'Garbage Record Book Part 1',
		type: 'MARPOL',
		bookType: EBookType.MARPOL,
	},
	{
		id: EMarpolBookId.GRB2,
		title: 'Garbage Record Book Part 2',
		type: 'MARPOL',
		bookType: EBookType.MARPOL,
	},
	{
		id: EMarpolBookId.BFL1,
		title: 'Biofouling Part 1',
		type: 'MARPOL',
		bookType: EBookType.MARPOL,
	},
	{
		id: EMarpolBookId.BFL2,
		title: 'Biofouling Part 2',
		type: 'MARPOL',
		bookType: EBookType.MARPOL,
	},
	{
		id: EMarpolBookId.ANNEX6,
		title: 'Annex VI',
		type: 'MARPOL',
		bookType: EBookType.MARPOL,
	},
	{
		id: EMarpolBookId.ANNEX6V2, // INFO: Name to be changed back to ANNEX6
		title: 'Annex VI - V2',
		type: 'MARPOL',
		bookType: EBookType.MARPOL,
	},
	{
		id: EMarpolBookId.BALLAST,
		title: 'Ballast Water Record',
		type: 'MARPOL',
		bookType: EBookType.MARPOL,
	},
	{
		id: EMarpolBookId.BALLAST_TANK_OPERATIONS,
		title: 'Ballast Tank Operations',
		type: 'MARPOL',
		bookType: EBookType.MARPOL,
	},
];

export const sealLogsBooks: Array<IBook> = [
	{
		id: 'sealLogs',
		title: 'Seal Logs',
		type: 'LOG',
		bookType: EBookType.LOG,
	},
];

export const landscapeOrientedBooks = [
	'GRB1',
	'GRB2',
	'BALLAST_TANK_OPERATIONS',
];

export const logInspectorViewLandscapeOrientedBooks = [
	'gmdssRadioConfig',
	'compassLogConfig',
	'portLogConfig',
	'engineLogConfig',
	'deckLogConfig',
];

export default inspectorConstants;
